import React, {useState, useEffect, useRef} from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import Brand from "./Brand";
import Purpose from "./Purpose";
import Others from "./Others";
import Ham from "./Ham";
import Search from "./Search";
import MobileHam from "./MobileHam";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import instance from "../../services/services";
import { BANNER_LIST_URL, CATEGORY_LIST_URL, JOIN_POINT_URL, HEADER_NOTICE_URL } from "../../utils/urls";
import korea from "../../assets/icon/korea.svg";
import japan from "../../assets/icon/japan.svg";
import taiwan from "../../assets/icon/taiwan.svg";
// import usa from "../../assets/icon/usa.png";
import noti from "../../assets/icon/noti.svg";
import ic_location from "../../assets/icon/ic_location.svg";
import lowest_price from "../../assets/icon/lowest_price.svg";
import reservation_guide from "../../assets/icon/reservation_guide.svg";
import instructions_use from "../../assets/icon/instructions_use.svg";
import download from "../../assets/icon/download.svg";
import white_ham from "../../assets/icon/white_ham.svg";
import white_srch from "../../assets/icon/white_srch.svg";
import black_ham from "../../assets/icon/black_ham.svg";
import black_srch from "../../assets/icon/black_srch.svg";
import useUserStore from "../../store/userStore";
import PopupLoginError from "../Popup/LoginError";
import { useLanguage } from "../../hooks/useLanguage";
import { useFooterData } from "../Footer/FooterContext";
import { formatUrl } from "../../utils/validation";
import others from "../../assets/img/empty.png"


function Header(){
  const { currentLanguage, changeLanguage, t } = useLanguage();
  const { footerData } = useFooterData();
  const isTablet = () => window.innerWidth >= 1280;
  const isMobile = () => window.innerWidth < 1280; // 모바일 화면 레이아웃 적용(1280px 이하)
  const location = useLocation();
  const [imgData, setImgData] = useState([]); 
  const [activeMenu, setActiveMenu] = useState(null); // pc 메뉴 
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);  // 모바일 햄버거 메뉴 
  const [clickedMenu, setClickedMenu] = useState(null);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const { logout, memberTokens } = useUserStore();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const [showLoginMessage, setShowLoginMessage] = useState(false);
  const [loginMessage, setLoginMessage] = useState("");
  const [isPopupLoginError, setIsPopupLoginError] = useState(false);
  const [joinPoint, setJoinPoint] = useState(0);
  const [headerNotice, setHeaderNotice] = useState([]); // 헤더 공지사항
  const [showLangMenu, setShowLangMenu] = useState(false); // 다국어 선택 드롭
  const [showFlagMenu, setShowFlagMenu] = useState(false); // 해외 국기 메뉴 드롭
  const [showAppMenu, setShowAppMenu] = useState(false); // APP 다운로드 메뉴 드롭 추가
  const flagMenuRef = useRef(null);
  const langMenuRef = useRef(null);
  const appMenuRef = useRef(null); // APP 메뉴 ref 추가

  // 다국어, 국기, APP 드롭박스 닫히게
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        langMenuRef.current && !langMenuRef.current.contains(event.target)
      ) {
        setShowLangMenu(false);
      }
      if (flagMenuRef.current && !flagMenuRef.current.contains(event.target)) {
        setShowFlagMenu(false);
      }
      if (appMenuRef.current && !appMenuRef.current.contains(event.target)) {
        setShowAppMenu(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const navbarRef = useRef(null); // 네비게이션 ref 추가
  const mainHeaderRef = useRef(null); // main_header ref 추가
  
  const [initialOffsetTop, setInitialOffsetTop] = useState(null); // 초기 오프셋 위치 저장용 상태
  const [mainHeaderInitialOffsetTop, setMainHeaderInitialOffsetTop] = useState(null); // main_header 초기 위치값
  // 드롭메뉴
  const [hoveredCategory, setHoveredCategory] = useState(null);

  // 로그인 상태 확인
  useEffect(() => {
    setIsLoggedIn(!!memberTokens);
  }, [memberTokens]);

  // 로그인/로그아웃 처리 함수
  const handleAuthAction = () => {
    if (isLoggedIn) {
      // 로그아웃 처리
      logout();
      setLoginMessage("로그아웃이 완료되었습니다.");
      setShowLoginMessage(true);
      
      // 메시지 표시 후 일정 시간 후 숨김
      // setTimeout(() => {
        setShowLoginMessage(false);
        navigate('/');
      // }, 500);
    } else {
      // 로그인 페이지로 이동
      navigate('/login');
    }
  };

  // 팝업 확인 버튼 클릭 핸들러 추가
  const handleConfirm = () => {
    navigate('/login');
  };

  // 로그인 필요한 기능 접근 처리
  const handleAuthRequired = (e, path) => {
    e.preventDefault();
    
        // 로그인 체크
        if (!memberTokens) {
          setIsPopupLoginError({
              message: t('login_required'),
              action: 'navigate_login'
          });
          return;
      }
    navigate(path);
  };

  // 모바일 햄버거 메뉴 열기 함수
  const handleMobileMenuOpen = () => {
    setIsMobileMenuOpen(true);
  };
  
  // 모바일 햄버거 메뉴 닫기 함수
  const handleMobileMenuClose = () => {
    setIsMobileMenuOpen(false);
  };
  
  // pc 메뉴 호버
  const handleMenuHover = (menuName, category) => {
    setActiveMenu(menuName);
    setHoveredCategory(category);
  
  };
  // pc 메뉴 호버 안할때
  const handleMenuLeave = ()=>{
    setActiveMenu(null);
  };
  
  // pc 메뉴 클릭시, 화살표 이미지 변경 (토글 기능 추가)
  const handleMenuClick = (menuName) => {
    // 이미 활성화된 메뉴를 다시 클릭하면 닫기
    if (clickedMenu === menuName) {
      setClickedMenu(null);
    } else {
      setClickedMenu(menuName);
    }
  };

// 검색팝업
const handleSearchOpen = () => {
  setIsSearchOpen(true);
  // 더 강력한 스크롤 막기
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.top = `-${window.scrollY}px`;
  document.body.style.width = '100%';
};

const handleSearchClose = () => {
  setIsSearchOpen(false);
  // 스크롤 복원
  const scrollY = document.body.style.top;
  document.body.style.overflow = '';
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.width = '';
  window.scrollTo(0, parseInt(scrollY || '0') * -1);
};

  // 카테고리 메뉴 이외 메뉴(about, community) 클릭 시 노란박스 해제
  useEffect(() => {
    const isCategoryPage =
      location.pathname.startsWith('/category/cinemaPage') ||
      location.pathname.startsWith('/category/cinemaPageSec');

    if (!isCategoryPage) {
      setClickedMenu(null);
    }
    // isCategoryPage일 때는 유지 (아무것도 하지 않음)
  }, [location.pathname]);
  

  // 헤더 배너 이미지 데이터
  useEffect(()=>{
    const getBannerList = async () => { 
        try {
            const response = await instance.post(BANNER_LIST_URL ,{
                b_type: "top",
                main_kind: "none"
            }
            );
            setImgData(response.data.data);
        } catch (error) {
            console.error("배너 리스트 조회 오류:", error);
        }
    };
    getBannerList();
  }, []);
  
  // 카테고리 리스트
  useEffect(()=> {
    const getCategoryList = async () => {
      try {
        const response = await instance.post(CATEGORY_LIST_URL);
        setCategoryList(response.data.data);
      } catch (error) {
        console.error("카테고리 리스트 조회 오류:", error);
      }
    };
    getCategoryList();
  }, []);

  // 가입 포인트 값
  useEffect(()=> {
    const getJoinPoint = async () => {
      try {
        const response = await instance.post(JOIN_POINT_URL);
        setJoinPoint(response.data.data.join_point);
      } catch (error) {
        console.error("가입 포인트 조회 오류:", error);
      }
    };
    getJoinPoint();
  }, []);

  // 헤더 공지사항
  useEffect(()=> {
    const getHeaderNotice = async () => {
      try {
        const response = await instance.post(HEADER_NOTICE_URL);
        setHeaderNotice(response.data.data);
      } catch (error) {
        console.error("헤더 공지사항 조회 오류:", error);
      }
    };
    getHeaderNotice();
  }, []);

  useEffect(() => {
    // 초기 오프셋 설정
    const updateOffsets = () => {
      if (navbarRef.current) {
        setInitialOffsetTop(navbarRef.current.offsetTop);
      }
      if (mainHeaderRef.current) {
        setMainHeaderInitialOffsetTop(mainHeaderRef.current.offsetTop);
      }
    };
    // 컴포넌트 마운트 시 초기값 설정
    updateOffsets();
    
    // 스크롤 이벤트 핸들러
    const handleScroll = () => {
      const isDesktop = window.innerWidth >= 1280;
      const scrollY = window.scrollY;
  
      if (isDesktop) {
        if (navbarRef.current) {
          navbarRef.current.classList.toggle('sticky', scrollY > initialOffsetTop);
        }
        if (mainHeaderRef.current) {
          mainHeaderRef.current.classList.remove('sticky');
        }
      } else {
        if (mainHeaderRef.current) {
          mainHeaderRef.current.classList.toggle('sticky', scrollY > mainHeaderInitialOffsetTop);
        }
        if (navbarRef.current) {
          navbarRef.current.classList.remove('sticky');
        }
      }
    };
    
    // 리사이즈 이벤트 핸들러
    const handleResize = () => {
      updateOffsets();
      handleScroll(); // 리사이즈 후 스크롤 상태 재확인
    };
      
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, [initialOffsetTop, mainHeaderInitialOffsetTop]); 

  // pc 우측 상단 > community 드롭메뉴
  const communityTabList = [
    { value: 'notice', name: t('notice') },
    { value: 'event', name: t('event') },
    { value: 'support', name: t('production_support') },
    { value: 'faq', name: t('frequently_asked_questions') },
    { value: 'inquiry', name: t('inquiry') },
    { value: 'customizing', name: t('customization') },
    { value: 'priceGuarantee', name: t('lowest_price_guarantee') },
    { value: 'credit', name: t('credit') },
  ];

  // pc 우측 상단 > about us 드롭메뉴
  const aboutTabList = [
    { value: 'intro', name: t('about_us') },
    { value: 'history', name: t('company_history') },
    { value: 'branch', name: t('branch_info') },
    { value: 'guide', name: t('reservation_guide') },
    { value: 'information', name: t('usage_guide') },
    { value: 'terms', name: t('terms_of_service') },
    { value: 'benefits', name: t('discount_info') },
  ];

  // 언어 변경 핸들러 추가
  const handleLanguageChange = (language) => {
    changeLanguage(language);
  };

  // 모바일에서 마이페이지일 때 네비게이션 숨기기 여부 체크
  const shouldHideNavigation = () => {
    const isMobile = window.innerWidth < 1280;
    const isMyPagePath = location.pathname.startsWith('/myPage');
    const isOrderVisitPath = location.pathname.startsWith('/order/visit');
    const isOrderParcelPath = location.pathname.startsWith('/order/parcel');
    const isOrderSalePath = location.pathname.startsWith('/order/sale');
    
    return isMobile && (isMyPagePath || isOrderVisitPath || isOrderParcelPath || isOrderSalePath);
  };

  return(
    <div>
      {/* 로그인/로그아웃 메시지 알림 */}
      {showLoginMessage && (
        <div className="login-message-popup">
          <div className="message-content">
            {loginMessage}
          </div>
        </div>
      )}

      <header className="layout_header">
        <div className="header_inner">

          {/* Left Area */}
          <div className="header_left_area">
            <div className="country_area">
              <div className="lang_wrap">

                {/* 해외 사이트 이동 */}
                <div className="lang_dropdown" ref={flagMenuRef}>
                  <div className="current_lang" onClick={() => setShowFlagMenu(!showFlagMenu)}>
                    <img src={korea} alt="language" /> {/* 항상 한국 국기 고정 */}
                  </div>
                  {showFlagMenu && (
                    <ul className="dropdown">
                      <li onClick={() => window.open(formatUrl('www.daypay.kr'), '_blank')}>
                        <img src={korea} alt="Korean" />
                      </li>
                      <li onClick={() => window.open(formatUrl('www.daypay.jp'), '_blank')}>
                        <img src={japan} alt="Japanese" />
                      </li>
                      <li onClick={() => window.open(formatUrl('www.daypay.tw'), '_blank')}>
                        <img src={taiwan} alt="Traditional Chinese" />
                      </li>
                      {/* <li onClick={() => window.open(formatUrl('/'), '_blank')}>
                        <img src={usa} alt="English" />
                      </li> */}
                    </ul>
                  )}
                </div>
              </div>

              <ul className="noti" style={{cursor: 'pointer'}}>
                <li style={{width:"16px", height:"16px"}}>
                  <img src={noti} alt="noti" />
                </li>
                <li style={{flex: 1, overflow: 'hidden', maxWidth: '192px'}}>
                  {headerNotice && headerNotice.length > 0 ? (
                    headerNotice.length === 1 ? (
                      // 데이터가 1개일 때는 그냥 표시
                      <span 
                        onClick={(notice) => navigate(`/community/notice/${notice.b_seq}`)}
                        style={{
                          display: 'block',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          maxWidth: '192px',
                          lineHeight: '20px',
                          fontWeight: '400',
                          color: '#7A7A7A'
                        }}
                      >
                        {headerNotice[0].subject}
                      </span>
                    ) : (
                      // 데이터가 여러개일 때는 Swiper로 롤링
                      <Swiper
                        modules={[Autoplay]}
                        autoplay={{ 
                          delay: 3000,
                          disableOnInteraction: false 
                        }}
                        slidesPerView={1}
                        direction="vertical"
                        loop={true}
                        className="notice-swiper"
                        style={{height: '20px', maxWidth: '192px'}}
                      >
                        {headerNotice.map((notice, index) => (
                          <SwiperSlide key={index}>
                            <span 
                              onClick={() => navigate(`/community/notice/${notice.b_seq}`)}
                              style={{
                                display: 'block',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: '192px',
                                lineHeight: '20px',
                                fontWeight: '400',
                                color: '#7A7A7A'
                              }}
                            >
                              {notice.subject}
                            </span>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    )
                  ) : (
                    // 데이터가 없을 때 기본 메시지
                    <span 
                      onClick={() => navigate('/community/notice')}
                    >
                      몰 오픈을 축하합니다.
                    </span>
                  )}
                </li>
              </ul>
            </div>

            {imgData.length > 0 && (
              <Swiper
                autoplay={{ delay: 3000 }}
                modules={[Pagination, Autoplay]}
                pagination={{ clickable: true }}
                slidesPerView={4}
                className="header_banner tablet_hide"
              >
                {imgData.map((top, idx) => (
                  <SwiperSlide key={idx}>
                    <Link href={top.link_url} target={`_${top.target_type}`}>
                      <img
                        alt={`서브 ${idx}`}
                        src={top.pc_thumb}
                        className="object-cover"
                      />
                    </Link>
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>

          {/* Logo Area */}
          <div className="logo_box">
            <div className="main_header" ref={mainHeaderRef}>
              <div 
                  className="left_con"
                  onClick={handleMobileMenuOpen} 
                  style={{marginTop: '5px'}}
              >
                <img src={black_ham} alt="icon-black-hamburger"/>
              </div>
              <h1 className="logo_box_logo">
                <Link 
                  to="/" 
                  className="logo"
                  style={{
                    backgroundImage: `url(${footerData?.logoImageTop?.value})`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = "/";
                  }}
                />
              </h1>
              <div 
                className="right_con"
                onClick={handleSearchOpen}
                style={{marginTop: '5px', position: 'relative', zIndex: '100'}}
              >
                <img src={black_srch} alt="icon-black-srch"/>
              </div>
            </div>
          </div>

          {/* Header Content */}
          <div className="header_content">
            <div className="top_con">
              <div className="yellow_point">
                <ul className="user_action flex-center">
                  {/* LOGIN/LOGOUT 버튼 */}
                  <li onClick={handleAuthAction} style={{cursor: 'pointer'}}>
                    {isLoggedIn ? 'LOGOUT' : 'LOGIN'}
                  </li>


                  {/* 로그인 상태에 따라 조건부 렌더링 */}
                  {!isLoggedIn && (
                    <li><Link to="/joinAgreement">JOIN</Link></li>
                  )}
                  
                  {/* 장바구니는 로그인 필요 */}
                  <li>
                    <span onClick={(e) => handleAuthRequired(e, '/order')} style={{cursor: 'pointer'}}>
                      CART
                    </span>
                  </li>
                  
                  {/* 마이페이지는 로그인 필요 */}
                  <li>
                    <span onClick={(e) => handleAuthRequired(e, '/myPage')} style={{cursor: 'pointer'}}>
                      MYPAGE
                    </span>
                  </li>
                  <li className="tablet_hide">
                    <div 
                      className="navi_item_with_submenu" 
                      onMouseEnter={() => setActiveMenu('community')}
                      onMouseLeave={() => setActiveMenu(null)}
                    >
                      <Link to="/community" className="navi_item">COMMUNITY</Link>

                      {activeMenu === 'community' && (
                        <div className="submenu">
                          {communityTabList.map((tab, index) => (
                            <Link
                              key={index}
                              to={`/community/${tab.value}`}
                              className="submenu-item"
                            >
                              {tab.name}
                            </Link>
                          ))}
                        </div>
                      )}
                    </div>
                  </li>
                  <li className="tablet_hide">
                    <div 
                      className="navi_item_with_submenu" 
                      onMouseEnter={() => setActiveMenu('about')}
                      onMouseLeave={() => setActiveMenu(null)}
                    >
                      <Link to="/about" className="navi_item">ABOUT US</Link>
                      

                      {activeMenu === 'about' && (
                        <div className="submenu">
                          {aboutTabList.map((tab, index) => (
                            <Link
                              key={index}
                              to={`/about/${tab.value}`}
                              className="submenu-item"
                            >
                              {tab.name}
                            </Link>
                          ))}
                        </div>
                      )}
                    </div>
                  </li>


                  {/* 모바일에서 이용안내, 지점안내 주석 */}
                  <li className="pc_hide">
                    <Link to="/about/information">
                      <div className="flex-center gap_1">
                        {t('usage_guide')}
                      </div>
                    </Link>
                  </li>
                  <li className="pc_hide">
                    <Link to="/about/branch">
                      <div className="flex-center gap_1">
                        {t('branch_info')}
                      </div>
                    </Link>
                  </li>
                  {/* 다국어 */}
                  <li className="lang_dropdown" ref={langMenuRef}>
                    <div className="current_lang" onClick={() => setShowLangMenu(!showLangMenu)}>
                      {currentLanguage === 'ko' ? 'KOR' :
                      currentLanguage === 'ja' ? 'JPN' :
                      currentLanguage === 'zh' ? 'TWN' : 'ENG'}
                    </div>
                    {showLangMenu && (
                        <ul className="dropdown">
                          <li onClick={() => { handleLanguageChange('ko'); setShowLangMenu(false); }} style={{fontSize: '12px', fontWeight: '400'}}>KOR</li>
                          <li onClick={() => { handleLanguageChange('ja'); setShowLangMenu(false); }} style={{fontSize: '12px', fontWeight: '400'}}>JPN</li>
                          <li onClick={() => { handleLanguageChange('zh'); setShowLangMenu(false); }} style={{fontSize: '12px', fontWeight: '400'}}>TWN</li>
                          <li onClick={() => { handleLanguageChange('en'); setShowLangMenu(false); }} style={{fontSize: '12px', fontWeight: '400'}}>ENG</li>
                        </ul>
                    )}
                  </li>
                </ul>
                {!isLoggedIn && (
                  <div className="joinPoint">
                    <p>+{joinPoint}P</p>
                  </div>
                )}
              </div>

              
              <ul className="user_action header_right_area flex-center tablet_hide icon-menu">
                <li className="ml-auto">
                  <Link to="/about/branch">
                    <div>
                      <div style={{display: 'flex', justifyContent: 'center'}}>
                        <img src={ic_location} alt="지점안내" className="icon" style={{width: '20px', height: '20px'}}/> 
                      </div>
                      {t('branch_info')}
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="/community/priceGuarantee">
                    <div>
                      <div style={{display: 'flex', justifyContent: 'center'}}>
                        <img src={lowest_price} alt="최저가보장" className="icon" style={{width: '20px', height: '20px'}}/> 
                      </div>
                      {t('price_guarantee')}
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="/about/guide">
                    <div>
                      <div style={{display: 'flex', justifyContent: 'center'}}>
                        <img src={reservation_guide} alt="예약가이드" className="icon" style={{width: '20px', height: '20px'}}/> 
                      </div>
                      {t('reservation_guide')}
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="/about/information">
                    <div>
                      <div style={{display: 'flex', justifyContent: 'center'}}>
                        <img src={instructions_use} alt="이용안내" className="icon" style={{width: '20px', height: '20px'}}/> 
                      </div>
                      {t('usage_guide')}
                    </div>
                  </Link>
                </li>
                <li>
                    <div className="app_dropdown" ref={appMenuRef}>
                      <div className="current_app" onClick={() => setShowAppMenu(!showAppMenu)}>
                        <div>
                          <div style={{display: 'flex', justifyContent: 'center'}}>
                            <img src={download} alt="APP 다운로드" className="icon" style={{width: '20px', height: '20px'}}/> 
                          </div>
                          {t('app_download')}
                        </div>
                      </div>
                      {showAppMenu && (
                        <ul className="dropdown">
                          <li onClick={() => window.open('https://play.google.com/store/apps/details?id=com.daypay.app', '_blank')}>
                            Android
                          </li>
                          <li onClick={() => window.open('https://apps.apple.com/app/daypay/id123456789', '_blank')}>
                            iOS
                          </li>
                        </ul>
                      )}
                    </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Navigation - 모바일 마이페이지에서만 조건부 렌더링 */}
        {!shouldHideNavigation() && (
          <nav 
            className="header_navi" 
            ref={navbarRef} 
            onMouseLeave={handleMenuLeave}
          >
            <ul className="inner navi_list">
              {/* 햄버거 메뉴 */}
              <li 
                className="white_hamburger" 
                onMouseEnter={() => handleMenuHover('hamburger', null)}
              >
                <img src={white_ham} alt="icon-black-hamburger" />
              </li>

              {/* 브랜드 */}
              <li 
                onMouseEnter={() => {
                  if(isTablet()){
                    handleMenuHover('brand', null)
                  }
                }} 
                onClick={() => {
                  if(!isTablet()){
                    handleMenuHover('brand', null)
                  } else{
                    handleMenuClick('brand')
                  }
                }}
              >
                {isMobile() ? (
                  <div className={`navi_item ${clickedMenu ===  'brand' ? 'active' : ''}`} >
                    <img src={categoryList[0]?.mobile_icon_url || others} alt="brand Icon" className="hide" />
                    BRAND
                  <div className={`imgicon ${clickedMenu ===  'brand' ? 'active' : ''}`}></div>
                </div>
                ) : (
                <Link 
                  to={{
                    pathname: `/category/cinemaPage`,
                    search: `?title=BRAND&category_code=0064`, // 브랜드는 값을 하드코딩으로 보내고있음(쿼리 파라미터 값으로 보냄).
                  }} 
                  className={`navi_item ${clickedMenu === 'brand' ? 'active' : ''}`}
                >
                  <img src={categoryList[0]?.mobile_icon_url || others} alt="brand Icon" className="hide" />
                  BRAND
                  <div className={`imgicon ${clickedMenu === 'brand' ? 'active' : ''}`}></div>
                </Link> 
                )
              }
              </li>

              {/* Purpose부터 Acc까지 카테고리 매핑 - BRAND 제외 */}
              {categoryList
                .filter(category => category.category_name !== 'BRAND') // BRAND 카테고리 제외
                .map((category, index) => {
                  return (
                    <li 
                      key={index}
                      onMouseEnter={()=>{
                        if(isTablet()){
                          handleMenuHover(
                            category.category_name === 'PURPOSE' ? 'purpose' : 'others',
                            category
                          )
                        }
                      }}
                      onClick={() => {
                        if(!isTablet()){
                          handleMenuHover(
                            category.category_name === 'PURPOSE' ? 'purpose' : 'others',
                            category
                          )
                        } else{
                          handleMenuClick(category.category_name)
                        }
                      }}
                    >
                      {/* 모바일이면서 PURPOSE인 경우 div 사용, 그 외에는 Link 사용 */}
                      {isMobile() && category.category_name === 'PURPOSE' ? (
                        <div className={`navi_item ${clickedMenu === category.category_name ? 'active' : ''}`}>
                          <img 
                            src={category?.mobile_icon_url || others} 
                            alt={`${category.category_name} Icon`} 
                            className="hide" 
                          />
                          <div>{category.category_name}</div>
                          <div className={`imgicon ${clickedMenu === category.category_name ? 'active' : ''}`}></div>
                        </div>
                      ) : (
                        <Link 
                          to={{
                            pathname: `/category/cinemaPage`,
                            search: `?title=${category.category_name}&category_code=${category.category_code}`,
                          }} 
                          className={`navi_item ${clickedMenu === category.category_name ? 'active' : ''}`}
                        >
                          <img 
                            src={category?.mobile_icon_url || others} 
                            alt={`${category.category_name} Icon`} 
                            className="hide" 
                          />
                          <div>{category.category_name}</div>
                          <div className={`imgicon ${clickedMenu === category.category_name ? 'active' : ''}`}></div>
                        </Link>
                      )}
                    </li>
                  );
                })}

              {/* 검색 */}
              <li 
                className="white_search"
                onMouseEnter={() => setActiveMenu('searchHover')}
                onMouseLeave={() => setActiveMenu(null)}
                onClick={handleSearchOpen}
              >
                <img src={white_srch} alt="icon-white-search" />
              </li>
            </ul>

            {/* 드롭다운 메뉴 - clickedMenu가 활성화되지 않은 경우에만 표시 */}
            <Ham 
              isOpen={activeMenu === 'hamburger'} 
              onDimHover={handleMenuLeave}
              categoryList={categoryList}
              onMenuClick={handleMenuClick}
            />
            <Brand 
              isOpen={activeMenu === 'brand' && clickedMenu !== 'brand'} 
              onDimHover={handleMenuLeave}
              onMenuClick={handleMenuClick}
            />
            <Purpose 
              isOpen={activeMenu === 'purpose' && clickedMenu !== 'PURPOSE'} 
              onDimHover={handleMenuLeave}
              categoryList={categoryList}
              onMenuClick={handleMenuClick}
            />
            <Others 
              isOpen={activeMenu === 'others' && clickedMenu !== hoveredCategory?.category_name} 
              onDimHover={handleMenuLeave}
              categoryList={categoryList}
              selectedCategory={hoveredCategory?.category_name}
              subCategories={hoveredCategory?.category2 || []}
              onMenuClick={handleMenuClick}
            />
            
            {/* 검색은 항상 표시 */}
            <Search 
              isOpen={isSearchOpen}
              onClose={handleSearchClose}
            /> 
          </nav>
        )}

        <MobileHam 
          isOpen={isMobileMenuOpen} 
          onClose={handleMobileMenuClose}
          categoryList={categoryList} 
        />
      </header>

      <PopupLoginError 
        isPopup={isPopupLoginError} 
        setIsPopup={setIsPopupLoginError}
        onConfirm={handleConfirm}
      />


      {/* 로그인/로그아웃 관련 스타일 추가 */}
      <style jsx="true">{`
        .login-message-popup {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background-color: rgba(0, 0, 0, 0.7);
          color: white;
          padding: 15px 25px;
          border-radius: 5px;
          z-index: 9999;
          animation: fadeIn 0.3s, fadeOut 0.3s 1.2s;
        }
        
        .message-content {
          font-size: 16px;
          text-align: center;
        }
        
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes fadeOut {
          from { opacity: 1; }
          to { opacity: 0; }
        }
      `}</style>
    </div>
  )
};

export default Header; 